export function getStunChoice(roomId) {
    const isEven = Number(roomId) % 2 === 0;
    return isEven ? 'stun2' : 'stun1';
}
